import React from 'react';

import classNames from 'classnames/bind';
import style from './MobileMenu.scss';
const ctx = classNames.bind(style);

import { Link } from 'react-router-dom';

class MobileMenu extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpened: !!props.isOpened,
    };
  }

  toggleMenu = event => {
    event.preventDefault();

    const { isOpened } = this.state;

    this.setState({
      isOpened: !isOpened,
    });
  };

  render() {
    const { isOpened } = this.state;
    const { items, active } = this.props;

    return (
      <div
        className={ctx('mobile-menu')}
        style={{ backgroundImage: `url(${'images/header-bg-mobile.png'})` }}
      >
        <div className={ctx('gals')}>
          <img src={'images/gals_logo.svg'} width="115px" height="32px" />
        </div>
        <div onClick={this.toggleMenu} className={ctx('burger')} />
        <div className={ctx('overlay', { 'overlay--isOpened': isOpened })}>
          <div className={ctx('closer')} onClick={this.toggleMenu} />
          <div className={ctx('inner')}>
            {items.map((item, idx) => (
              <div className={ctx('item-container')}>
                <Link
                  to={item.link}
                  key={idx}
                  className={ctx('item', {
                    'item--isActive': item.key === active,
                  })}
                >
                  {item.title}
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default MobileMenu;
